// TODO: deprecate
import React from 'react'
import { shape, array, oneOfType, func, string } from 'prop-types'
import yn from 'yn'
import { setIsCommercial } from '../../redux/ferryRouteSelections/actions'
import { useDispatch } from 'react-redux'

if (yn(process.env.REACT_APP_COMPONENT_ENABLE_ROUTE_GROUPINGS)) {
  require('../../styles/scss/components/ferryRoutes/ferry-routes-groupings.scss')
}

const FerryRoutesGroupings = ({
  serviceMessageContent,
  openModal,
  closeModal,
  modalIsOpen,
  activeGrouping,
  labels,
  routesGroupings,
  toggleRouteGrouping
}) => {
  const dispatch = useDispatch()
  let renderGroupings = []

  for (const groupingKey in routesGroupings) {
    const currentGrouping = routesGroupings[groupingKey]
    const routeGroupingLabels = currentGrouping.routeText.split('-')

    if (
      currentGrouping.ferryId &&
      currentGrouping.path &&
      currentGrouping.routeText
    ) {
      renderGroupings.push(
        <div
          className="ferry-routes__grouping"
          key={`routes-grouping-${currentGrouping.ferryId}`}
        >
          <div
            className="ferry-routes__grouping-content"
            style={{ backgroundImage: `url(${currentGrouping.path})` }}
          >
            <img
              className="u-remove-element"
              src={currentGrouping.path}
              alt={currentGrouping.routeText}
            />

            <div className="ferry-routes__grouping-overlay">
              <h4 className="ferry-routes__grouping-heading">
                {routeGroupingLabels[0] && (
                  <span className="heading-departure">
                    {routeGroupingLabels[0]}
                    {routeGroupingLabels[1] && ` - `}
                  </span>
                )}

                {routeGroupingLabels[1] && (
                  <span className="heading-arrival">
                    {routeGroupingLabels[1]}
                  </span>
                )}
              </h4>

              <div className="ferry-routes__grouping-brand">
                <button
                  className="btn btn-alt"
                  onClick={() => {
                    toggleRouteGrouping(currentGrouping.ferryId, true, false)
                    dispatch(setIsCommercial(false))
                    if (
                      serviceMessageContent &&
                      currentGrouping.ferryId &&
                      serviceMessageContent[currentGrouping.ferryId]
                    ) {
                      if (
                        !Object.keys(modalIsOpen).includes(
                          'ferry-service-message'
                        )
                      ) {
                        openModal({
                          type: 'ferry-service-message',
                          message:
                            serviceMessageContent[currentGrouping.ferryId]
                        })
                      }
                    }
                  }}
                  disabled={activeGrouping === currentGrouping.ferryId}
                >
                  {labels.bookToday}
                </button>

                {currentGrouping.logoPath && (
                  <img src={currentGrouping.logoPath} alt="Toggle Route" />
                )}
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  return renderGroupings ? (
    <div className="ferry-routes__groupings">
      <div className="u-container">{renderGroupings}</div>
    </div>
  ) : null
}

FerryRoutesGroupings.propTypes = {
  serviceMessageContent: shape(),
  openModal: func.isRequired,
  closeModal: func.isRequired,
  modalIsOpen: shape().isRequired,
  activeGrouping: string,
  labels: shape().isRequired,
  routesGroupings: oneOfType([array, shape()]).isRequired,
  toggleRouteGrouping: func.isRequired
}

export default FerryRoutesGroupings
